import { onMounted, onUnmounted } from 'vue'
import { getPhantomBindings, type PhantomMountHooks } from './controller'

export function usePhantomResumeOnMount(deps: PhantomMountHooks): void {
  const owner = getPhantomBindings()
  onMounted(() => owner.acquire(deps))
  onUnmounted(() => {
    owner.release()
  })
}
